import { EMAIL_ADDRESSES } from '@/lib/constants'
import {
  SessionMetadataItem,
  SessionMetadataUser,
} from '@/types/responses/session-metadata'

interface ContactUsEmailContext {
  currentUser?: SessionMetadataUser
  currentCompany?: SessionMetadataItem['currentCompany']
}

class HelpService {
  openEmailClient(context: ContactUsEmailContext) {
    document.location.href = this.buildMailtoUrl(context)
  }

  buildMailtoUrl(context: ContactUsEmailContext) {
    return `mailto:${
      EMAIL_ADDRESSES.rqSupport
    }?subject=${encodeURIComponent(this.buildSubject(context))}`
  }

  buildSubject({ currentUser, currentCompany }: ContactUsEmailContext) {
    if (currentUser && currentCompany) {
      return `Support request from ${currentUser.fullName} at ${currentCompany.presentationName}`
    }

    if (currentUser) {
      return `Support request from ${currentUser.fullName}`
    }

    if (currentCompany) {
      return `Support request from ${currentCompany.presentationName}`
    }

    return 'Support request'
  }
}

const helpService = new HelpService()

export default helpService
